import React from 'react';
import { Grid, Typography } from '@mui/material';
import IReportColumn from '../../interfaces/IReportColumn';
import IReportGroup from '../../interfaces/IReportGroup';
import GroupedReportWithoutTable from '../GroupedReportWithoutTable';

export default function GroupedReportWithoutData({ columns, twoLevelsGroups }:
  {
    readonly twoLevelsGroups: readonly IReportGroup[],
    readonly columns: readonly IReportColumn[]
  }) {

  return (
    <Grid
      container
      marginTop={1}
    >
      {twoLevelsGroups.map((group) => {
        return (
          <Grid
            item
            key={Math.random() + group.count}
            xs={24}
            marginTop={2}
          >
            <Typography
              variant="body2"
              fontWeight={'bold'}
              marginTop={2}
            >
              {group.label}
              {group.count ? ` (Total : ${group.total}) ` : ''}
            </Typography>
            <Grid
              item
              sx={{ marginLeft: '16px' }}
            >
              <GroupedReportWithoutTable isTwoLevels={true} groups={group.groups} columns={columns} />
            </Grid>
          </Grid>
        )
      })}

    </Grid>
  )
}